import React, {useEffect, useRef, useState} from 'react';
import { Button, Col, notification, PageHeader, Row, Table } from 'antd';
import { DownloadOutlined, ReloadOutlined } from '@ant-design/icons';
import { downloadD365ExpenseFile, listD365ExpenseFiles } from '../../api/d365Api';
import moment from 'moment/moment';
import { PREFERRED_DATETIME_FORMAT } from '../../util/time';
import { downloadCsvFile } from '../../util/download';
import {getPaginationConfig} from "../../util/showAllPagination";
import {useDynamicTableHeight} from "../../util/useDynamicTableHeight";

const ExpenseFiles = () => {
  const [ files, setFiles ] = useState([]);
  const [ loading, setLoading ] = useState(false);
  const [downloadStatus, setDownloadStatus] = useState(false);
  const tableContainerRef = useRef(null);
  const tableHeight = useDynamicTableHeight(tableContainerRef);
  const columns = [
    {
      title: 'Filename',
      dataIndex: 'filename',
      sorter: (a, b) => a.filename.localeCompare(b.filename),
    },
    {
      title: 'Size (KB)',
      width: 200,
      dataIndex: 'sizeBytes',
      sorter: (a, b) => a < b,
      render: b => (b / (1024)).toFixed(2)
    },
    {
      title: 'Updated At',
      width: 200,
      dataIndex: 'updatedAt',
      sorter: (a, b) => a.updatedAt.localeCompare(b.updatedAt),
      render: i => i ? moment.utc(i).local().format(PREFERRED_DATETIME_FORMAT) : '-'
    },
    {
      title: 'Actions',
      width: 200,
      render: r => (
        <Button icon={<DownloadOutlined/>}
                loading={downloadStatus}
                onClick={() => downloadExpenseFile(r)}
        >
          Download
        </Button>
      )
    }
  ];

  const downloadExpenseFile = async (file) => {
    try {
      const res = await downloadD365ExpenseFile(file.filename);

      if (res) {
        if (res.data) {
          downloadCsvFile(res.data, file.filename);
        } else if (res.error) {
          notificationError(res.error);
        } else {
          console.error(res)
          notificationError('Unknown error - see console');
        }
      }
    } catch (e) {
      console.error(`Could not download expense file ${file.filename}`, e);
      notificationError('Unknown error - see console');
    } finally {
      setDownloadStatus(false);
    }

  };

  const notificationError = (msg) => {
    console.error(msg)
    notification.error({
      message: 'Error',
      description: msg,
      placement: 'bottomRight',
      duration: 10,
    });
  };

  const load = async () => {
    setLoading(true);
    const files = await listD365ExpenseFiles();
    setFiles(files);
    setLoading(false);
  };

  useEffect(() => {
    load();
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <Row>
        <Col span={12}>
          <PageHeader
            title="Expense Files"
            subTitle={`(${files.length} shown)`}
            style={{ padding: 0 }}
          />
        </Col>
      </Row>

      <Row style={{ marginBottom: 10 }}>
        <Col flex="auto"></Col>
        <Col>
          <Button
            style={{ float: 'right' }}
            onClick={() => load()}
            loading={loading}
            icon={<ReloadOutlined/>}
          >
            Refresh
          </Button>
        </Col>
      </Row>

      <Table
        ref={tableContainerRef}
        rowKey="ID"
        dataSource={files}
        columns={columns}
        pagination={getPaginationConfig(files.length)}
        size="small"
        loading={loading}
        scroll={{y: tableHeight }}
      />
    </>
  );
};

export { ExpenseFiles };
